/* ============
 * Getters for the patient module
 * ============
 *
 * The getters that are available on the
 * patient progress module.
 */
import { clone } from '@/utils/object';

const getPatientProgresses = state => clone(state.patientProgressList);
const getPatientProgressDetails = state => clone(state.patientProgressDetails);
const getLoading = state => clone(state.loading);
const getTotalCount = state => clone(state.totalCount);
const getIsPatientProgressListloading = state => clone(state.isPatientProgressListloading);
const getIsPatientProgressloading = state => clone(state.isPatientProgressloading);

export default {
  getPatientProgresses,
  getPatientProgressDetails,
  getLoading,
  getTotalCount,
  getIsPatientProgressListloading,
  getIsPatientProgressloading
};
